import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "../../lib/motion";
import { SECTORS } from "../../lib/sectors";
import { StatusLabel, TypesList } from "./SectorParts";

const sector = SECTORS[1];

const SectorCommercial = () => (
    <section
        data-testid="sector-commercial-section"
        className="relative py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <div className="grid gap-12 lg:grid-cols-12 lg:gap-0">
                <motion.div
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="show"
                    viewport={viewportOnce}
                    className="lg:z-10 lg:self-center lg:col-span-5"
                >
                    <div className="border border-white/12 bg-[#0B132B] p-8 shadow-[0_24px_60px_rgba(0,0,0,0.5)] md:p-10 lg:-mr-20">
                        <div className="flex flex-wrap items-center gap-4">
                            <span className="font-mono text-[13px] tracking-[0.3em] text-cad">
                                {sector.n}
                            </span>
                            <StatusLabel
                                tier={sector.tier}
                                id="sector-status-commercial"
                            >
                                {sector.status}
                            </StatusLabel>
                        </div>
                        <h2
                            data-testid="sector-commercial-headline"
                            className="mt-6 font-display text-3xl font-semibold leading-[1.1] text-white md:text-4xl"
                        >
                            {sector.title}
                        </h2>
                        <p className="mt-6 text-[16px] leading-relaxed text-mist">
                            {sector.copy}
                        </p>
                    </div>
                </motion.div>

                <motion.figure
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="show"
                    viewport={viewportOnce}
                    className="group relative overflow-hidden lg:col-span-8 lg:col-start-5"
                >
                    <img
                        src={sector.image}
                        alt={sector.alt}
                        loading="lazy"
                        className="aspect-[16/9] w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                    />
                    <figcaption className="absolute bottom-0 left-0 bg-[#0A0F1D]/85 px-4 py-2 font-mono text-[13px] tracking-[0.22em] text-mist backdrop-blur-sm">
                        {sector.caption}
                    </figcaption>
                </motion.figure>
            </div>

            <TypesList
                types={sector.types}
                idPrefix="sector-commercial"
                className="mt-14 border-t border-white/10 pt-6"
            />
        </div>
    </section>
);

export default SectorCommercial;
